import { defineComponent as _defineComponent } from 'vue'
import WujieVue from 'wujie-vue2';
import { onUnmounted } from 'vue';
import { MICRO_NAME, MICRO_URL, UPDATE_BUTTON_VISIBLE_EVENT, UPDATE_HIGHLIGHT_ENABLED_EVENT } from './constants';
import { useChemicalEntry } from './composables/use-chemical-entry';
import { usePermission } from '@/composables/use-permission';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChemicalEntry',
  setup(__props) {

const { permissions } = usePermission();
const { getWujieProps, updateButtonVisible, updateHighlightEnabled } = useChemicalEntry();

const wujieProps = getWujieProps();

WujieVue.bus.$on(UPDATE_BUTTON_VISIBLE_EVENT, updateButtonVisible);
WujieVue.bus.$on(UPDATE_HIGHLIGHT_ENABLED_EVENT, updateHighlightEnabled);

onUnmounted(() => {
    WujieVue.bus.$off(UPDATE_BUTTON_VISIBLE_EVENT, updateButtonVisible);
    WujieVue.bus.$off(UPDATE_HIGHLIGHT_ENABLED_EVENT, updateHighlightEnabled);
});

return { __sfc: true,permissions, getWujieProps, updateButtonVisible, updateHighlightEnabled, wujieProps, WujieVue, MICRO_NAME, MICRO_URL }
}

})